import { PAGE_CODE } from "../helper/constant"
const STAGES_INFO = {
    REQUEST_DETAILS: "request-detail",
    LOCATION_DETAILS: "location-detail",
    PACKAGE_DETAILS: "pack-details",
    ASSET_DETAILS: "asset-details",
    MATERIAL_DETAILS: "material-details",
    MATERIAL_FOR_EXTERNAL_MARKET: "material-for-external-market",
    ADDITIONAL_INFO_DETAILS: "additional-info-details",
    COLLECTION_DETAILS: "collection-detail",
    SERVICE_DETAILS: "service-detail",
    QUOTE_DETAILS: "quote-detail",
    FINAL_REVIEW: "final-review",
    CUSTOMER_DETAILS: "cust-detail",
    PROCESSING_SITE_DETAILS: "site-details",
    BOX_DETAILS: "box_details",
    EXTRA_SERVICES_DETAILS: "extra_service_details",
    ONSITE_SERVICE_DETAILS: "onsite_service_details",
    SERVICE_DATE: "service_date",
    SCHEDULE_DATE_STATUS: "schedule_date_status",
    SCHEDULE_DATE_STAGE: "schedule_date_stage",
    DESTINATION_ADDRESS: "destination_address",
    SOURCE_ADDRESS: "source_address",
    CARRIER_DETAIL: "carrier_detail",
    LABELS_DETAIL: "labels_detail",
    ADDITIONAL_FIELDS: "additional_fields",
    CONTACT_DETAILS: "contact_details",
    REQUEST_ADDITIONAL_EMAIL_RECEPIENTS: "additional_email_recepients",
    ADDITIONAL_PICKUP_NOTE: "pickup_note",
    ADDITIONAL_PO_DATA: "po_data",
    REQUEST_ASSET_QUOTATION: "asset_quotation",
    EVENT_STEP: "event_note",
    CIRCLE_ORDER: "circle-order",
    ASSET_IMAGES: "asset_image",
    PICKUP_DATE: "pickup_date",
    QUOTE_REQUEST_CONTACT: "quote_request_contact",
    LOGISTICS_CONTENT: "logistics_content",
    ASSETS_AND_SERVICES: "assets-and-services",
    MATERIALS_AND_SERVICES: "materials-and-services",
    MATERIAL_CONTAINER: "material_container",
    PROCESSING_CARRIER_INFO: "processing_carrier_info"
}


const STATUS_CONDITIONS = {
    NEW: 'new',
    APPROVED: 'approved',
    PACK_DATE_ASSIGNED: "pack_date_assigned",
    PICKUP_DATE_ASSIGNED: "pick_date_assigned",
    SCHEDULE_DATE: "schedule_date_status",
    DATE_CONFIRMED: "date_confirmed",
    PICKUP_DATE_CONFIRMED: "pickup_date_confirmed",
    PICKUP_DONE: 'pickup_done',
    REACHED_FACILITY: 'reached_facility',
    PROCESSING_STARTED: 'processing_started',
    PROCESSING_DONE: 'processing_done',
    SERVICE_DATE_EVENT: 'service_date',
    REPORTING_DONE: 'reporting_done',
    COD_DONE: 'cod_done',
    COMPLETED_DATE: 'completed',
    SERVICE_DATE: 'service_date',
    COD_COMPLETED: "cod_completed",
    DONATION_SENT: 'donation_sent',
    DELIVERED_DATE: 'delivered_date',
    CANCEL_REJECTED: 'cancel_rejected',
    AUDIT_BOOKING_REPORT: 'audit_booking_report',
    BOOKING_REPORTS: "booking_reports",
    RECEPTION_REPORTS: "reception_reports",
    RECYCLING_RECEPTION_REPORTS: "recycling_reception_reports",
    REVENUE_SHARE_REPORTS: "revenue_share_reports",
    SERVICEFEE_BOOKING_REPORTS: "servicefee_booking_reports",
    SETTLEMENT_REPORTS: "settlement_reports",
    VALUE_BACK_REPORTS: "value_back_reports",
}

export const EXTRA_SERVICE_MATCHKEYS = {
    DEFAULT_DISPLAY_SERVICES: 'only-default-display'
}
export const SERVICE_DATE_STATUSES = ['client_approved', 'client_reject', 'admin_reject', 'none']
export const REQUEST_TYPE_ACTIONS = ['parcel_ship']
// 1 - Return Label ; 2 - Box and Return Label
export const PARCEL_SHIP_REQUEST_DATA = [1, 2]

export const STAGES = STAGES_INFO
export const STATUS_ACTION_KEY_NAMES = STATUS_CONDITIONS
export const NO_ACCESS_PORTAL_CODE = 'NO-PORTAL-ACCESS'

export const MAP_STAGE_NAMES = {
    [STAGES_INFO.ADDITIONAL_FIELDS]: `HeadlineCustomFields`,
    [STAGES_INFO.COLLECTION_DETAILS]: `HeadlineCollectionSite`,
    [STAGES_INFO.REQUEST_DETAILS]: `HeadlineCollectionSite`,
    [STAGES_INFO.ASSET_DETAILS]: `HeadlineAssets`,
    [STAGES_INFO.SERVICE_DETAILS]: `HeadlineServices`,
    [STAGES_INFO.ADDITIONAL_INFO_DETAILS]: `HeadlineAdditionalInformation`,
    [STAGES_INFO.ASSETS_AND_SERVICES]: `HeadlineAssetsAndServices`,
    [STAGES_INFO.MATERIALS_AND_SERVICES]: `HeadlineMaterialsAndServices`,
    [STAGES_INFO.MATERIAL_DETAILS]: `HeadlineMaterials`,
    [STAGES_INFO.CONTACT_DETAILS]: `HeadlineRequestContacts`,
    [STAGES_INFO.DESTINATION_ADDRESS]: `LabelDestinationSite`,
    [STAGES_INFO.QUOTE_REQUEST_CONTACT]:`HeadlineQuoteRequestContactInformation`,
    [STAGES_INFO.MATERIAL_CONTAINER]:`HeadlineMaterialContainer`,
    [STAGES_INFO.SCHEDULE_DATE_STAGE]:`HeadlineScheduleDateStage`,
    [STAGES_INFO.EVENT_STEP]:`HeadlineEventNote`,
    [STAGES_INFO.PROCESSING_CARRIER_INFO]:`HeadlineProcessingCarrier`,
    [STAGES_INFO.EXTRA_SERVICES_DETAILS]:`HeadlineExtraServices`,
    [STAGES_INFO.MATERIAL_FOR_EXTERNAL_MARKET]:`HeadlineMaterialsForExternalMarket`,
}

export const SHOW_ON_CLIENT_USER = [
	STAGES.ADDITIONAL_FIELDS, 
	STAGES.REQUEST_DETAILS, 
	STAGES.DESTINATION_ADDRESS, 
	STAGES.ASSET_DETAILS, 
	STAGES.ASSETS_AND_SERVICES, 
	STAGES.MATERIAL_CONTAINER, 
	STAGES.CONTACT_DETAILS, 
	STAGES.QUOTE_REQUEST_CONTACT, 
	STAGES.MATERIAL_DETAILS,
	STAGES.MATERIALS_AND_SERVICES,
	STAGES.ADDITIONAL_INFO_DETAILS,
    STAGES.PROCESSING_CARRIER_INFO,
    STAGES.MATERIAL_FOR_EXTERNAL_MARKET
]